import { render, staticRenderFns } from "./order_link.vue?vue&type=template&id=60e42967&scoped=true"
import script from "./order_link.vue?vue&type=script&lang=js"
export * from "./order_link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e42967",
  null
  
)

export default component.exports